import { StyledIndicator } from './Indicator.styled';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';

export default function Indicator({ isCorrect }) {
  return (
    <StyledIndicator className={`indicator ${isCorrect ? 'is-correct' : ''}`}>
      {isCorrect ? <CheckOutlined /> : <CloseOutlined />}
    </StyledIndicator>
  );
}
